import React from 'react';

import Link from '../../components/Link';
import {useAnalytics} from '../../hooks';
import {getResizedLessonThumbnail} from '../../util';

const LessonCard = ({
  lesson,
  lessonMapping,
}) => {
  const {tracker} = useAnalytics();

  return (
    <Link
      href={`/courses/${lessonMapping[lesson.slug]}/${lesson.slug}`}
      className="flex items-center"
      onClick={() => tracker.companyClickLesson({lesson: lesson.slug})}
    >
      <img
        className="rounded-lg h-16 w-24 mr-3 object-cover"
        src={getResizedLessonThumbnail(lesson, 200, 200)}
        alt={lesson.title}
      />
      <div className="flex flex-col">
        <span className="text-sm font-medium text-gray-700">
          {lesson.shortTitle}
        </span>
        <span className="text-sm text-indigo font-medium">
          {lesson.video ? 'Video Answer' : 'Sample Answer'}
        </span>
      </div>
    </Link>
  );
};

export default LessonCard;
